// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import coinsIcon from './icons/coins.svg';
import paymentConfirmedIcon from './icons/payment-cofirmed.svg';
import paymentPhoneIcon from './icons/payment-phone.svg';

type Props = {
  iconSrc: string,
  text?: string,
  iconAlt?: string,
};

export function MpcreditoInstructions(): Node {
  return (
    <Root>
      <DisplayInformation
        iconSrc={paymentPhoneIcon}
        text="Crie uma conta ou entre no <b>Mercado Pago</b>."
        iconAlt="Mercado Crédito"
      />
      <DisplayInformation
        iconSrc={paymentConfirmedIcon}
        text="Solicite consulta ou <b>limite disponível</b>."
        iconAlt="Mercado Crédito"
      />
      <DisplayInformation
        iconSrc={coinsIcon}
        text="Escolha em quantas <b>vezes quer pagar e pronto</b>."
        iconAlt="Mercado Crédito"
      />
    </Root>
  );
}

function DisplayInformation({iconSrc, text, iconAlt}: Props): Node {
  return (
    <InformationBox>
      <IconWrapper>
        <Icon src={iconSrc} alt={iconAlt}/>
      </IconWrapper>
      <Info dangerouslySetInnerHTML={{ __html: text }} />
    </InformationBox>
  );
}

const Root = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px;
`;

const InformationBox = styled.div`
  width: 100%;
  display: flex;
  font-style: normal;
  font-size: 14px;
  line-height: 1.3em;
  letter-spacing: -0.01em;
  align-items: center;
  padding: 16px 0;
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
`;

const IconWrapper = styled.div`
  display: inline-block;
  margin-right: 32px;
  margin-left: 16px;
  width: 32px;
  height: 32px;
`;

const Info = styled.div`
  width: 100%;
  display: inline-block;
  font-style: normal;
  font-size: 14px;
  letter-spacing: -0.01em;
`;
